module.exports = "<th> {%- date %} </th>";


//////////////////
// WEBPACK FOOTER
// ./src/components/scheduler/html/templates/dateContainer.html
// module id = 1171
// module chunks = 1